import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

import { catchError, EMPTY, OperatorFunction, throwError } from 'rxjs';

import { DialogService } from 'dspx-core';

import { PopupInfo } from '../interfaces/popup-info.interface';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(
    private dialogService: DialogService) {
  }

  public errorHandler(customErrorPopups?: Map<HttpStatusCode, PopupInfo>): OperatorFunction<any, any> {
    return catchError((error: HttpErrorResponse) => {
      const customErrorPopup = customErrorPopups?.get(error?.error?.StatusCode);
      if (customErrorPopup) {
        this.dialogService.showPopup(customErrorPopup.popupCode, customErrorPopup.model, customErrorPopup.data);
        return EMPTY;
      }

      // Custom handling of form validation errors
      if (error?.error?.StatusCode === 400 && error?.error?.Message) {
        const message = this.serverValidationErrorsToHtml(error?.error?.Message);
        this.dialogService.showSimplePopup(message, 'Unable to continue', 'OK');
        return EMPTY;
      }

      // Remapping error codes from strings to numbers (e.g. 'UpdatedSinceReadTime' => 2).
      // This is because the global error handler expects the numerical codes instead of the string codes,
      // whereas the API returns the server-side error enum as strings instead of codes.
      if (error?.status === 400 && error?.error?.status) {
        const statusMapping = {
          'NoMatchingRow': 1,
          'UpdatedSinceReadTime': 2,
          'Success': 3,
          'InsertFailed': 4,
          'UpdateFailed': 5,
          'DuplicateRow': 6,
          'InvalidAction': 7,
          'DuplicateChildEntity': 8
        };
        error.error.status = statusMapping[error.error.status] ?? error.error.status;
      }

      // Let the global error handler handle the error
      return throwError(error);
    });
  }

  private serverValidationErrorsToHtml(validationErrors: string): string {
    return this.stringArrayToHtmlUnorderedList(this.serverValidationErrorsToStringArray(validationErrors));
  }

  private stringArrayToHtmlUnorderedList(array: string[]): string {
    const listItems = (array && array.map(item => `<li>${item}</li>`)) || [];
    return `<ul>${listItems.join('')}</ul>`;
  }

  private serverValidationErrorsToStringArray(validationErrors: string): string[] {
    return (validationErrors && validationErrors.split('\r\n').map(x => x && x.trim()).filter(x => !!x)) || [];
  }
}
